import { getTheme, Icon, IStyle, ITheme, Link, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { BwjPalette } from '../../../../app-core/app-theme';
import { noWrapStyle } from '../../../../framework/utils/no-wrap-style';
import { BwjText, BwjTextSize } from '../../../../framework/components/bwj-text';

interface IInfoLineProps {
  icon?: string | undefined;
  text: string;
  onClick?: (() => void) | undefined;
  color?: string | undefined;
  rootStyle?: React.CSSProperties | undefined;
}

const getStyleClasses = (theme: ITheme, color: string | undefined) => {
  const root: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.2rem',
    alignItems: 'center',
    color: color ?? BwjPalette.themeInfo,
  };

  const icon: IStyle = {
    display: 'block',
    fontSize: theme.fonts.smallPlus.fontSize,
    lineHeight: theme.fonts.smallPlus.fontSize,
  };

  const text: IStyle = {
    ...noWrapStyle as unknown as {},
    fontSize: theme.fonts.small.fontSize,
    lineHeight: theme.fonts.small.lineHeight,
  };

  return mergeStyleSets({
    root,
    icon,
    text,
  });
}

const getLinkStyles = (theme: ITheme, clr: string | undefined) => {
  const color = clr ?? BwjPalette.themeInfo;
  return {
    root: {
      color,
      fontSize: theme.fonts.small.fontSize,
      lineHeight: theme.fonts.small.lineHeight,

      '&:hover': {
        color,
      },
      '&:active': {
        color,
      },
      '&:active:hover': {
        color,
      },
      '&:focus': {
        color,
      },
    },
  };
}

export const InfoLine: React.FunctionComponent<IInfoLineProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme, props.color);
  const linkStyles = getLinkStyles(theme, props.color);

  return (
    <div
      className={cs.root}
      style={props.rootStyle}
    >
      {!!props.icon &&
      <Icon
        className={cs.icon}
        iconName={props.icon}
        aria-label='Tip'
      />}
      {!!props.onClick ?
      <Link
        styles={linkStyles}
        onClick={props.onClick}
      >
        {props.text}
      </Link>
      :
      <BwjText
        className={cs.text}
        textSize={BwjTextSize.smallPlus}
      >
        {props.text}
      </BwjText>}
    </div>
  );
};
